export enum TelemetrySystem {
    ProductGroup = 'telemetry_system.product_group',
    Machine = 'telemetry_system.machine',
    Ui = 'telemetry_system.ui',
    Option = 'telemetry_system.option',
}
